// @flow
import type {
  AssetOperator,
} from '../types'

// Constants
import { MODEL } from 'fc-model-assets'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: AssetOperator = composeOperator({
  model: MODEL,
})

export default operator
